module.exports = __webpack_public_path__ + "static/media/call_smartphone.d19bf531.png";